<template>
  <b-container fluid>
    <div class="horizontal-menu">
      <b-row>
        <b-col>
          <h2>Video Templates</h2>
        </b-col>
        <b-col class="float-right">
          <!-- Actions -->
        </b-col>
      </b-row>

      <b-nav>
        <b-nav-item :to="{name: 'projects'}" active-class="tab_active">Video Templates</b-nav-item>
        <b-nav-item :to="{name: 'projects_quality_control'}" exact exact-active-class="tab_active">Quality Control</b-nav-item>
      </b-nav>
    </div>

    <b-container>
      <b-alert v-if="profile.team.plan === null" variant="danger" class='text-center' show><strong>Please upgrade</strong> - You cannot add videos until you upgrade your plan</b-alert>
      <b-alert v-else-if="profile.avatar.status != constants.voice_status.complete" variant="danger" class='text-center' show><strong>Voice is disabled</strong> - You cannot add videos until it is enabled</b-alert>
    </b-container>

    <keep-alive include="project_list">
      <router-view :profile="profile" :user="user"/>
    </keep-alive>
  </b-container>
</template>

<script>
export default {
  props: ['profile', 'user']
}
</script>

<style>

</style>
